import { render, staticRenderFns } from "./wsDeleteDialog.vue?vue&type=template&id=757a1409&scoped=true&"
import script from "./wsDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./wsDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a1409",
  null
  
)

export default component.exports